<template>
  <div v-if="bundle">
    <v-btn
      fab
      small
      class="extra-small"
      color="primary"
      depressed
      @click="$emit('onDelete')"
      style="position: absolute; top: 0; right: 0;margin-top: -15px;margin-right: -15px;"
    >
      <i class="fa fa-trash middle"></i>
    </v-btn>
    <v-layout wrap>
      <v-flex xs6 sm3 class="form-control pa-1">{{ $t('Price range') }} {{ index + 1 }}</v-flex>
      <v-flex xs6 sm3 class="form-control pa-1">
        <input
          type="text"
          :name="'bundle_minquantity_' + index"
          :data-vv-name="'bundle_minquantity_' + index"
          :data-vv-as="$t('Minimum Price Range')"
          v-validate="index == 0 ? 'required|numeric|min_value:1' : 'required|numeric'"
          maxlength="4"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :id="`minquantityInput_${index}`"
          :placeholder="$t('Minimum Price Range')"
          v-model="bundle.minquantity"
          :disabled="index != 0"
        />
      </v-flex>
      <v-flex xs6 sm3 class="form-control pa-1">
        <input
          type="text"
          :name="'bundle_maxquantity_' + index"
          :data-vv-name="'bundle_maxquantity_' + index"
          :data-vv-as="$t('Maximum Price Range')"
          v-validate="'required|numeric|min_value:' + bundle.minquantity"
          maxlength="4"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :id="`maxquantityInput_${index}`"
          :placeholder="$t('Maximum Price Range')"
          v-model="bundle.maxquantity"
        />
      </v-flex>
      <v-flex xs6 sm3 class="form-control pa-1">
        <input
          type="text"
          :name="'bundle_price_' + index"
          :data-vv-name="'bundle_price_' + index"
          :data-vv-as="$t('Price per unit')"
          maxlength="13"
          v-validate="'required|decimal:2|min_value:1'"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :id="`priceInput_${index}`"
          :placeholder="$t('Price per unit')"
          v-model="bundle.price"
        />
        <!-- isBundleLessThanMainPrice:'+price +'|isBundleLessThanLastPrice:'+ lastBundlePrice -->
      </v-flex>
    </v-layout>
    <div
      class="form-control"
      :class="{
        'has-error':
          errors.has('bundle_maxquantity_' + index) ||
          errors.has('bundle_minquantity_' + index) ||
          errors.has('bundle_price_' + index)
      }"
    >
      <span class="text-error" v-if="errors.has('bundle_minquantity_' + index)">{{
        errors.first('bundle_minquantity_' + index)
      }}</span>
      <span class="text-error" v-else-if="errors.has('bundle_maxquantity_' + index)">{{
        errors.first('bundle_maxquantity_' + index)
      }}</span>
      <span class="text-error" v-else-if="errors.has('bundle_price_' + index)">
        <template
          v-if="
            errors.first('bundle_price_' + index) ==
              'Normal Price must be higher than Wholesale Price'
          "
          >{{
            $t('Normal Price must be higher than Wholesale Price', {
              item: $t('Price range') + ' ' + (index + 1)
            })
          }}</template
        >
        <template
          v-else-if="
            errors.first('bundle_price_' + index) == 'Price must be cheaper than previous price'
          "
          >{{
            $t('Price must be cheaper than previous price', {
              item: $t('Price range') + ' ' + (index + 1)
            })
          }}</template
        >
        <template v-else>{{ errors.first('bundle_price_' + index) }}</template>
      </span>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'

const isLess = (value, { price } = {}) => {
  try {
    if (parseFloat(price) > 0) {
      return parseFloat(value) < parseFloat(price)
    } else {
      return true
    }
  } catch (error) {
    return false
  }
}
const paramNames = ['price']
Validator.extend(
  'isBundleLessThanMainPrice',
  {
    validate: isLess,
    getMessage: field => 'Normal Price must be higher than Wholesale Price'
  },
  { paramNames }
)

Validator.extend(
  'isBundleLessThanLastPrice',
  {
    validate: isLess,
    getMessage: field => 'Price must be cheaper than previous price'
  },
  { paramNames }
)

export default {
  props: {
    minBundle: {
      default: null,
      type: Number
    },
    value: {
      deafult: undefined
    },
    index: {
      default: null
    },
    price: {
      default: 0
    },
    lastBundlePrice: {
      default: 0
    }
  },
  inject: ['$validator'],
  data: function() {
    return {
      bundle: undefined
    }
  },
  mounted: function() {
    if (this.value) {
      this.bundle = this.value
      if (this.index > 0) {
        this.bundle.minquantity = this.minBundle + 1
      }
    }
  },
  watch: {
    bundle: function() {
      this.$emit('input', this.bundle)
    },
    value: function() {
      if (this.value) {
        this.bundle = this.value
        if (this.index > 0) {
          this.bundle.minquantity = this.minBundle + 1
        }
      }
    },
    minBundle: function() {
      if (this.index > 0) {
        this.bundle.minquantity = this.minBundle + 1
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AddBundle.vue